import { ApplyButton } from 'shared/widgets/ApplyButton'
import styles from './DatesForm.module.css'
import { DataRangePicker2 } from 'shared/ui/strspykit/DataRangePicker2/DataRangePicker2'
import { Controller, useForm } from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'
import { DateTime } from 'luxon'
import * as z from 'zod'
import { ClearButton } from 'shared/widgets/ClearButton'
interface DatesFormProps{
    value: any,
    isLoading?: boolean
    onSubmit: (value: any, event: any) => void
}

const intervalDateSchema = z.object({
  startDate: z.custom<DateTime>(
        (val) => {
           return val instanceof DateTime && val.isValid
        },
        { message: 'Invalid Start Date' }
    ),
  endDate: z.custom<DateTime>(
        (val) => {
                return val instanceof DateTime && val.isValid 
            },
        { message: 'Invalid End Date' }
    ),
})

const formSchema = z.object({
    periods: z
        .array(intervalDateSchema)
        .min(1)
}).passthrough()


type FormData = z.infer<typeof formSchema>

export const DatesForm = (props: DatesFormProps): JSX.Element => {
    const {
        value,
        isLoading = false,
        onSubmit
    } = props

    const {
        register,
        handleSubmit,
        reset,
        control,
        setValue,
        formState: { errors, isDirty, isValid },
    } = useForm<FormData>({
        resolver: zodResolver(formSchema),
        mode: 'onChange',
        defaultValues: value,
    })

    const handleFormSubmit = (value: any, event: any) => {
        onSubmit?.(value, event)
    }  

    return (
        <form
            onSubmit={handleSubmit(handleFormSubmit)}
        >   
                <Controller
                    name="periods"
                    control={control}
                    render={({
                        field: { onChange, onBlur, value, name, ref },
                        fieldState: { invalid, isTouched, isDirty, error },
                        formState: { dirtyFields },
                    }) => (
                        <div className={styles.FlexibleForm__FormControl}>
                            <label 
                                className={styles.FlexibleForm__FormLabel}
                                htmlFor={name}
                            >
                            </label>                       
                            <DataRangePicker2
                                value={value}
                                onValueChange={
                                    (event) => {     
                                        onChange(event)
                                    }
                                }
                            /> 
                                
                        </div>    
                                      
                    )}
                />

        </form>
    )
}